import { inactiveProjectTag } from '@/lib/archived-projects';
import { cn } from '@/lib/utils';

interface ProjectFilterLabelProps {
  name: string;
  color: string;
  status: string;
}

/**
 * One project row of a project filter: its colour, its name, and — for an
 * archived or on-hold project — its state as a muted tag, so an archived twin
 * never reads as its active namesake. [HW-951]
 */
export function ProjectFilterLabel({ name, color, status }: ProjectFilterLabelProps) {
  const tag = inactiveProjectTag(status);
  return (
    // One line in the closed trigger too: the name gives way (truncates) and the
    // tag does not, so a narrow trigger still says which twin is the archived one.
    <span className={cn('flex min-w-0 items-center gap-2', tag && 'text-muted-foreground')}>
      <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: color }} />
      <span className="truncate">{name}</span>
      {tag && <span className="shrink-0 whitespace-nowrap text-xs text-muted-foreground">· {tag}</span>}
    </span>
  );
}
